module.exports = __webpack_public_path__ + "img/main.63f23445.jpg";